export class WebhookV1StandardPayloadBackupJobFailed {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadBackupJobFailedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadBackupJobFailedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobFailed.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadBackupJobFailedTypeEnum;
(function (WebhookV1StandardPayloadBackupJobFailedTypeEnum) {
    WebhookV1StandardPayloadBackupJobFailedTypeEnum["BackupJobFailed"] = "BACKUP_JOB_FAILED";
})(WebhookV1StandardPayloadBackupJobFailedTypeEnum || (WebhookV1StandardPayloadBackupJobFailedTypeEnum = {}));
